export default __webpack_public_path__ + "static/media/fish_oil6.e1186409.png";